import React, { useEffect, useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Row, Col, Button, Input } from "antd";
import "./SurfacePreparationsInt.less";
import { BulletIcon } from "../../../../utils/icons";
import SurfacePrepInt from "../pop-ups/SurfacePrepIntModal";
import { useDispatch } from "react-redux";
import {
  deleteSurfaceDefaults,
  postSurfaceDefaults,
  updateSurface,
} from "../../../../redux/proposal-defaults-com-res/action";

type Props = {
  jobType: string;
  type: string;
  surfaces?: any;
};

const SurfacePreparationsDefault = (props: Props) => {
  const dispatch = useDispatch();
  const [showSurfacePrepIntModal, setShowSurfacePrepIntModal] = useState(false);
  const [data, setData] = useState<any>([]);

  const [edit, setEdit] = useState<any>({});

  useEffect(() => {
    setData(props.surfaces);
  }, [props.surfaces]);

  const handleSurfaceAdd = (data: any) => {
    if (Object.keys(edit)?.length > 0) {
      const body = {
        ...edit,
        ...data,
      };
      dispatch(updateSurface(body));
    } else {
      const body = {
        ...data,
        type: props.type,
        jobType: props.jobType,
      };
      dispatch(postSurfaceDefaults(body));
    }
    setShowSurfacePrepIntModal(false);
  };

  const toggleSurfacePrepIntModal = (collapse: boolean) => {
    !showSurfacePrepIntModal
      ? setShowSurfacePrepIntModal(true)
      : setShowSurfacePrepIntModal(false);
  };

  const handleAdd = () => {
    setEdit({});
    !showSurfacePrepIntModal
      ? setShowSurfacePrepIntModal(true)
      : setShowSurfacePrepIntModal(false);
  };

  const handleEdit = (index: number, row: any) => {
    setEdit(row);
    setShowSurfacePrepIntModal(true);
  };

  const handleDelete = (id: string) => {
    dispatch(deleteSurfaceDefaults(id));
  };

  const handleTitleChange = (e: any, id: string) => {
    const index = data?.findIndex((item: any) => item._id === id);
    const newData = [...data];
    newData[index].title = e.target.value;
    setData(newData);
  };

  const handleDetailChange = (e: any, id: string) => {
    const index = data?.findIndex((item: any) => item._id === id);
    const newData = [...data];
    newData[index].detail = e.target.value;
    setData(newData);
  };

  return (
    <div className="surface-preparation-interior">
      <SurfacePrepInt
        row={edit}
        title={props.jobType}
        toggleSurfacePrepIntModal={toggleSurfacePrepIntModal}
        showSurfacePrepIntModal={showSurfacePrepIntModal}
        handleSurfaceAdd={handleSurfaceAdd}
      />
      <Row justify="space-between">
        <Col>
          <h1>Surface Preparations ({props.jobType})</h1>
        </Col>
        <Col>
          <Button
            onClick={handleAdd}
            className="surface-preparation-add-btn"
            type="link"
          >
            + Add
          </Button>
        </Col>
      </Row>

      <Row>
        {data?.map((item: any, index: any) => {
          return (
            <Col span={24} key={item._id}>
              <Row gutter={15}>
                <Col span={20}>
                  <Row>
                    <Col span={1}>
                      <BulletIcon />
                    </Col>
                    <Col span={23}>
                      {edit === index ? (
                        <Row>
                          <Col span={11}>
                            <Input
                              onChange={(e: any) =>
                                handleTitleChange(e, item._id)
                              }
                              value={item.title}
                            />
                          </Col>
                          <strong>:</strong>
                          <Col span={12}>
                            <Input
                              onChange={(e: any) =>
                                handleDetailChange(e, item._id)
                              }
                              value={item.detail}
                            />
                          </Col>
                        </Row>
                      ) : (
                        <>
                          <strong>{item.title}:</strong>
                          {item.detail}
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col>
                  <EditOutlined
                    onClick={() => handleEdit(index, item)}
                    style={{ color: "#FDB913", cursor: "pointer" }}
                  />
                </Col>
                <Col>
                  <DeleteOutlined
                    onClick={() => handleDelete(item._id)}
                    style={{ color: "#D2232A", cursor: "pointer" }}
                  />
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default SurfacePreparationsDefault;
